import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, ChangeDetectorRef, Component, NgModule} from '@angular/core';

import { AppComponent } from './app.component';
// import { CesiumDirective } from './directives/cesium.directive';
import { DrawingEditorToolsComponent } from './components/drawing-editor-tools/drawing-editor-tools.component';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule, DecimalPipe} from '@angular/common';
import { EventItemsComponent } from './components/event-items/event-items.component';
import {AppInjector} from './classes/appInjector';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faCalendar,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faEllipsisV,
  faEuroSign,
  faEye,
  faEyeSlash,
  faFilter,
  faLock,
  faCopy,
  faLockOpen,
  faMapPin,
  faPlane,
  faSquare,
  faTrash,
  faGlobe,
  faGlobeEurope,
  faPalette,
  faStar,
  faPlusCircle,
  faUndo,
  faAdjust,
  faBuilding,
  faMapMarker,
  faSearch,
  faPlusSquare,
  faMinusSquare,
  faSync,
  faUnlock,
  faLink,
  faMap,
  faGlobeAmericas,
  faRedo,
  faExchangeAlt,
  faClock,
  faTag,
  faArrowCircleRight,
  faFilePdf,
  faFileImage,
  faFileUpload,
  faDesktop,
  faPlus,
  faArrowAltCircleUp,
  faObjectUngroup,
  faTimesCircle,
  faAngleDoubleRight,
  faCheck, faObjectGroup,
  faExclamationCircle,
  faMapMarkerAlt,
  faPencilAlt,
  faMapMarkedAlt, faEdit
} from "@fortawesome/free-solid-svg-icons";
import { DrawingHintComponent } from './components/drawing-hint/drawing-hint.component';
import { ServerConnectionStatusComponent } from './components/server-connection-status/server-connection-status.component';
import {ObjectOptionsComponent} from "./components/object-options/object-options.component";
import { RotationOptionComponent } from './components/itemOptions/rotation-option/rotation-option.component';
import { BottomHintDirective } from './directives/bottomHint/bottom-hint.directive';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { AfterSettingsComponent} from "./components/after-settings/after-settings.component";
import { ItemSettingsComponent } from './components/item-settings/item-settings.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MapObjectPlugin} from "./classes/plugins/MapObjectPlugin";
import {StaticParamsPlugin} from "./classes/plugins/StaticParamsPlugin";
import {UploadPlugin} from "./classes/plugins/UploadPlugin";
import {MapInfoWindowPlugin} from "./classes/plugins/MapInfoWindowPlugin/MapInfoWindowPlugin";
import {Item} from "./models/Item";
import {BabyNumbersPlugin} from "./classes/plugins/BabyPlugin/BabyNumbersPlugin";
import {BeforeItemComponent} from "./components/before-item/before-item.component";
import {MapTextOverlayPlugin} from "./classes/plugins/mapTextOverlay/MapTextOverlayPlugin";
import {MapViewsComponent} from "./components/map-views/map-views.component";
import {ConcreteLayersComponent} from "./components/concrete-layers/concrete-layers.component";
import {CameraRotateThreeDComponent} from "./components/camera-rotate-three-d/camera-rotate-three-d.component";
import {BabyNumberComponent} from "./classes/plugins/BabyPlugin/baby-number/baby-number.component";
import {InfoWindowAfsComponent} from "./classes/plugins/MapInfoWindowPlugin/info-window-afs-component/info-window-afs.component";
import {ServerConnectionPlugin} from "./classes/plugins/ServerConnectionPlugin/ServerConnectionPlugin";
import {ImageInputComponent} from "./components/image-input/image-input.component";
import {FileInputComponent} from "./components/file-input/file-input.component";
import {StorySlidesComponent} from "./components_2.1/story-slides/story-slides.component";
import {FixedSizeComponent} from "./components/fixed-size/fixed-size.component";
import {OverlaysComponent} from "./components/overlays/overlays/overlays.component";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {OverlayComponent} from "./components/overlays/overlay/overlay.component";
import { ItemElementComponent } from './components/item-element/item-element.component';
import {ItemListenerPlugin} from "./classes/plugins/ItemListenerPlugin/ItemListenerPlugin";
import { MultidropComponent } from './components/multidrop/multidrop.component';
import {ModalModule} from "ngx-bootstrap/modal";
import { CanvasStoreComponent } from './components/canvas-store/canvas-store.component';
import {TabsModule} from "ngx-bootstrap/tabs";
import { UndoComponent } from './components/undo/undo.component';
import { SelectedItemsGroupComponent } from './components/selected-items-group/selected-items-group.component';
import { SearchLocationComponent } from './components/search-location/search-location.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BwTogglerComponent } from './components/bw-toggler/bw-toggler.component';
import {FilterPipe} from "./components/event-items/filter.pipe";
import { ZoomControlsComponent } from './components/zoom-controls/zoom-controls.component';
import {ObjectZoomPlugin} from "./classes/plugins/ZoomConfigs/ObjectZoomPlugin";
import {W3wObjectsPlugin} from "./classes/plugins/w3wObjectsPlugin";
import {SortByPipe} from "./classes/pipes/orderFilter";
import { PerspectivesComponent } from './components/perspectives/perspectives.component';
import {ParticipantPlugin} from "./classes/plugins/ParticipantPlugin/ParticipantPlugin";
import { ItemParticipantComponent } from './classes/plugins/ParticipantPlugin/item-participant/item-participant.component';
import { SidebarParticipantComponent } from './classes/plugins/ParticipantPlugin/sidebar-participant/sidebar-participant.component';
import { EventsListSelectComponent } from './components_2.1/events-list-select/events-list-select.component';
import { RealtimeUsersComponent } from './components/realtime-users/realtime-users.component';
import { Draggable } from './directives/ngInit/ng-draggable.directive';
import {ConcreteLayerPlugin} from "./classes/concreteLayers/ConcreteLayerPlugin";
import { GlobalObjectsLockComponent } from './components/global-objects-lock/global-objects-lock.component';
import { LastHeaderBtnsComponent } from './components/last-header-btns/last-header-btns.component';
import {MobileLastHeaderBtnsComponent} from './components/mobile-last-header-btns/mobile-last-header-btns.component'
import { SocketConnectionModalComponent } from './components/socket-connection-modal/socket-connection-modal.component';
import {RealtimeUsersComponent21} from "./components_2.1/realtime-users/realtime-users.component";
import {AppComponent21} from "./components_2.1/app-component/app.component";
import {SearchLocationComponent21} from "./components_2.1/search-location/search-location.component";
import {MapViewsComponent21} from "./components_2.1/map-views/map-views.component";
import {BwTogglerComponent21} from "./components_2.1/bw-toggler/bw-toggler.component";
import {ServerConnectionStatusComponent21} from "./components_2.1/server-connection-status/server-connection-status.component";
import {DrawingEditorToolsComponent21} from "./components_2.1/drawing-editor-tools/drawing-editor-tools.component";
import {CameraRotateThreeDComponent21} from "./components_2.1/camera-rotate-three-d/camera-rotate-three-d.component";
import { PlacedItems21Component } from './components_2.1/placed-items21/placed-items21.component';
import { PlacedItemComponent } from './components_2.1/placed-item/placed-item.component';
import { ItemDetailsSidebarComponent } from './components_2.1/item-details-sidebar/item-details-sidebar.component';
import {ObjectOptionsComponent21} from "./components_2.1/object-options/object-options.component";
import {BabyNumberComponent21} from "./components_2.1/baby-number/baby-number.component";
import {ItemSettingsComponent21} from "./components_2.1/item-settings/item-settings.component";
import {ItemParticipantComponent21} from "./components_2.1/item-participant/item-participant.component";
import {RotationOptionComponent21} from "./components_2.1/rotation-option/rotation-option.component";
import { InternalFloorsComponentComponent } from './components_2.1/internal-floors-component/internal-floors-component.component';
import {ZoomControlsComponent21} from "./components_2.1/zoom-controls/zoom-controls.component";
import {UiAdapterService} from "./services/uiAdapterService/ui-adapter.service";
import {ConcreteLayerService} from "./services/concreteLayer/concrete-layer.service";
import {CesiumAdapterService} from "./services/cesiumAdapter21/cesium-adapter.service";
import {isDisableBabyNumber, isRemoveSidebar} from "../configs/view_only";
import { LayoutsTabComponent } from './components_2.1/layouts-tab/layouts-tab.component';
import { OverlayTabItemComponent } from './components_2.1/overlay-tab-item/overlay-tab-item.component';
import { OverlayType2TabItemComponent } from './components_2.1/overlay-type2-tab-item/overlay-type2-tab-item.component';
import {GroupByPipe} from "./classes/pipes/groupingFilter";
import {GroupByTimeline} from "./classes/pipes/groupByTimeline";
import {FixedSizeComponent21} from "./components_2.1/fixed-size/fixed-size.component";
import {FigureZoomPlugin} from "./classes/plugins/figureZoomPlugin/FigureZoomPlugin";
import {GroupByOverlayGroupPipe} from "./classes/pipes/groupingOverlaysFilter";
import {DynamicImageCodePlugin} from "./classes/plugins/DynamicImageCodePlugin";
import { GlobalMeasurementComponent } from './components_2.1/global-measurement/global-measurement.component';
import { LockModalComponent } from './components_2.1/lock-modal/lock-modal.component';
// import {WhiteTooltipDirective} from "./directives/whiteTooltip/white-tooltip.directive";
import { RotateHandlerComponent } from './components_2.1/rotate-handler/rotate-handler.component';
import { NextSiblingComponentComponent } from './components_2.1/next-sibling-component/next-sibling-component.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { TimelineComponent } from './components_2.1/timeline/timeline.component';
import { TimelineSliderComponent } from './components_2.1/timeline-slider/timeline-slider.component';
import {TimelinePlugin} from "./classes/plugins/TimelinePlugin";
import { ImageModalComponent } from './components_2.1/image-modal/image-modal.component';
import {VideoModalComponent} from "./components_2.1/video-modal/video-modal.component";
import {VideoPin} from "./classes/plugins/videoPin/VideoPin";
import {RotateObject} from "./classes/plugins/rotateObjectPlugin/RotateObject";
import { GlobalScreenshotComponent } from './components_2.1/global-screenshot/global-screenshot.component';
import { ConfirmModalComponent } from './components_2.1/confirm-modal/confirm-modal.component';
import { EmailSendingConfirmModalComponent } from './components_2.1/email-sending-confirm-modal/email-sending-confirm-modal.component';
import { DownloadModalComponent } from './components_2.1/download-modal/download-modal.component';
import { LeftSidebarSubitemComponent } from './components_2.1/left-sidebar-subitem/left-sidebar-subitem.component';
import { ItemLocationComponent } from './components_2.1/item-location1/item-location.component';
import { ObjectArrayComponent } from './classes/plugins/objectArrayPlugin/object-array-component/object-array.component';
import {ObjectArrayPlugin} from "./classes/plugins/objectArrayPlugin/object-array-plugin";
import { GpxImportComponent } from './components_2.1/gpx-import/gpx-import.component';
import { GpxModalComponent } from './components_2.1/gpx-modal/gpx-modal.component';
import { ImportsContainerComponent } from './components_2.1/imports-container/imports-container.component';
import {filterByFieldLength} from "./classes/pipes/filterByFieldLength";
import { CadAutoImportComponent } from './components_2.1/cad-auto-import/cad-auto-import.component';
import { CadAutoImportModalComponent } from './components_2.1/cad-auto-import-modal/cad-auto-import-modal.component';
import { CadAutoConfirmComponent } from './components_2.1/cad-auto-confirm/cad-auto-confirm.component';
import { AutoCadSaveComponent } from './components_2.1/auto-cad-save/auto-cad-save.component';
import {DynamicIconPlugin} from "./classes/plugins/DynamicIconPlugin";
import { SearchResultContainerComponent } from './components_2.1/search-result-container/search-result-container.component';
import { MyPositionComponent } from './components_2.1/my-position/my-position.component';
import { HomeLinkComponent } from './components_2.1/home-link/home-link.component';
import { TutorialListComponent } from './components_2.1/tutorial-list/tutorial-list.component';
import {OpeningHoursPlugin} from "./classes/plugins/OpeningHoursPlugin";
import {CrowdLevelPlugin} from "./classes/plugins/CrowdLevelPlugin";
import {InjectAttributesPlugin} from './classes/plugins/InjectAttributesPlugin';
import { MultiSelectSquareToolComponent } from './components_2.1/multi-select-tool/multi-select-square-tool.component';
import { ExchangeItemsComponent } from './components_2.1/exchange-items/exchange-items.component';
import { MultiselectTopGroupComponent } from './components_2.1/multiselect-top-group/multiselect-top-group.component';
import {MultiSelectFloorplanModal} from "./components_2.1/multi-select-floorplan-modal/multi-select-floorplan-modal";
import { VersionsComponent } from './components_2.1/versions/versions.component';
import { ImagePanolensComponent } from './components_2.1/image-panolens/image-panolens.component';
import {ToastModule} from './components_2.1/toast/toast.module';
import {PagePreloadComponent} from "./components_2.1/page-preload/page-preload.component";
import {ColorPickerModule} from './components_2.1/color-picker/color-picker.module';
import {GeneratePresentationModalComponent} from "./components_2.1/generate-presentation-modal/generate-presentation-modal.component";
import { PptxStoryModalComponent } from './components_2.1/pptx-story-modal/pptx-story-modal.component';
import { EditStoryComponent } from './components_2.1/edit-story/edit-story.component';
import { SlideNameComponent } from './components_2.1/slide-name/slide-name.component';
import {AutosizeModule} from "ngx-autosize";
import { CmsNotificationComponent } from './components_2.1/cms-notification/cms-notification.component';
import { CustomerStoriesModalComponent } from './components_2.1/customer-stories-modal/customer-stories-modal.component'
import { CustomerStoryPreviewComponent } from './components_2.1/customer-story-preview/customer-story-preview.component'
import { EditEventModalComponent } from './components_2.1/edit-event-modal/edit-event-modal.component'
import { DemoMaterialModule } from './material-module'
import { CoreModule } from '@core/core.module';
import {PlacedItemConcreteComponent} from "./components_2.1/placed-item-concrete/placed-item-concrete.component";
import {PlacedItemItemComponent} from "./components_2.1/placed-item-item/placed-item-item.component";
import {ItemFolder} from "./components_2.1/item-folder/item-folder.component";
import {ItemAdditionalBlockComponent} from "./components_2.1/item-additional-block/item-additional-block.component";
import {ItemAdditionalActionsComponent} from "./components_2.1/item-additional-actions/item-additional-actions.component";
import {ItemAdditionalBlockListComponent} from "./components_2.1/item-additional-block-list/item-additional-block-list.component";
import {NgDragDropModule} from "ng-drag-drop";
import {GroupAdditionalBlockComponent} from "./components_2.1/group-additional-block/group-additional-block.component";
import {GroupAdditionalBlockListComponent} from "./components_2.1/group-additional-block-list/group-additional-block-list.component";
import {GroupSidebarComponent} from "./components_2.1/group-sidebar/group-sidebar.component";
import { GroupRemoveConfirmationModalComponent } from './components_2.1/group-remove-confirmation-modal/group-remove-confirmation-modal.component';
import {HeartbeatService} from 'src/app/services/heartbeat/heartbeat.service';
import {UserGuideModule} from '@modules/user-guide/user-guide.module';
import {SharedModule} from '@shared/shared.module';
import { MapMoveComponent } from './components_2.1/map-move/map-move.component';
import { OpacitySliderComponent } from './components_2.1/opacity-slider/opacity-slider.component';
import {EsBootstrapAlertsComponent} from "@src/app/components_2.1/bootstrap-alerts-component/bootstrap-alerts-component";
import { CloseAlertsDirective } from './directives/closeAlerts/close-alerts.directive';
import {PaywallModule} from '@modules/paywall/paywall.module';
import { SceneRotationComponent } from './components_2.1/scene-rotation/scene-rotation.component';
import { ExportProgressIndicatorComponent } from './ui/export-progress-indicator/export-progress-indicator.component';
import { BetaBadgeComponent } from './ui/beta-badge/beta-badge.component';
import {ShareIconComponent} from './components_2.1/icons/share-icon/share-icon.component'
import {ArrowInSquareIconComponent} from './components_2.1/icons/arrow-in-square-icon/arrow-in-square-icon.component'
import {DownloadIconComponent} from './components_2.1/icons/download-icon/download-icon.component'
import {MonitorIconComponent} from './components_2.1/icons/monitor-icon/monitor-icon.component';
import { EditStoryHiddenContainerComponent } from './components_2.1/edit-story-hidden-container/edit-story-hidden-container.component'
import { PresetComponent } from './components_2.1/preset/preset.component';
import {SetUpPlugin} from '@src/app/classes/plugins/setUpPlugin/SetUpPlugin';
import { ModalComponent } from './core/components/modal/modal.component';
import { LinkShareModalComponent } from './components_2.1/link-share-modal/link-share-modal.component';
import { LinkShareAccessNudgeModalComponent } from './components_2.1/link-share-access-nudge-modal/link-share-access-nudge-modal.component';
import { NearmapLimitComponent } from './components_2.1/nearmap-limit/nearmap-limit.component';
import { VertexModalComponent } from './components_2.1/vertex-modal/vertex-modal.component';
import { VertexOptionButtonComponent } from './components_2.1/vertex-option-button/vertex-option-button.component';
import {VertexPlugin} from "./classes/plugins/VertexPlugin/VertexPlugin";
import {CalculationPlugin} from "@src/app/classes/plugins/CalculationPlugin/CalculationPlugin";
import {WhiteTooltipModule} from '@src/app/directives/whiteTooltip/white-tooltip.module';
import { ObjectArrayConfirmModalComponent } from './components_2.1/object-array-confirm-modal/object-array-confirm-modal.component';
import {CarouselModule} from 'ngx-bootstrap/carousel';


// BabyNumbersPlugin

window['isIOS'] = function() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return ([
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
    'MacIntel'
  ].includes(window.navigator.platform) || /iphone|ipod|ipad/.test(userAgent)) && window.navigator.maxTouchPoints > 2;
};

window['isMac'] = ()=>{
  return window.navigator.userAgent.indexOf("Mac") != -1;
}

const plugins = (isRemoveSidebar) ? [MapObjectPlugin] : [
  MapObjectPlugin, StaticParamsPlugin, BabyNumbersPlugin, MapTextOverlayPlugin,
  MapInfoWindowPlugin, ServerConnectionPlugin, ItemListenerPlugin, W3wObjectsPlugin, ObjectZoomPlugin, ParticipantPlugin,
  ConcreteLayerPlugin, FigureZoomPlugin, DynamicImageCodePlugin, TimelinePlugin, VideoPin, RotateObject, ObjectArrayPlugin,
  DynamicIconPlugin, OpeningHoursPlugin, CrowdLevelPlugin, InjectAttributesPlugin, SetUpPlugin, VertexPlugin, CalculationPlugin
];

if (isDisableBabyNumber) {
  plugins.splice(2, 1);
}


// ObjectZoomPlugin

const self = this;
plugins.map((plugin) => Item.addPlugin(plugin));
// plugins.map((plugin) => plugin.getUsedComponents());

const declaredComponents2 = [
  AppComponent,
  // CesiumDirective,
  DrawingEditorToolsComponent,
  EventItemsComponent,
  DrawingHintComponent,
  ServerConnectionStatusComponent,
  AfterSettingsComponent,
  ObjectOptionsComponent,
  RotationOptionComponent,
  BottomHintDirective,
  TooltipDirective,
  ItemSettingsComponent,
  BeforeItemComponent,
  MapViewsComponent,
  ConcreteLayersComponent,
  CameraRotateThreeDComponent,
  BabyNumberComponent,
  InfoWindowAfsComponent,
  ImageInputComponent,
  FileInputComponent,
  StorySlidesComponent,
  FixedSizeComponent,
  OverlaysComponent,
  MultidropComponent,
  UndoComponent,
  SelectedItemsGroupComponent,
  SearchLocationComponent,
  BwTogglerComponent,
  OverlayComponent,
  ItemElementComponent,
  CanvasStoreComponent,
  ZoomControlsComponent,
  GlobalObjectsLockComponent,
  LastHeaderBtnsComponent,
  MobileLastHeaderBtnsComponent,
  SocketConnectionModalComponent,
  RealtimeUsersComponent,
  ItemParticipantComponent,
  VideoModalComponent,
  ShareIconComponent,
  ArrowInSquareIconComponent,
  DownloadIconComponent,
  MonitorIconComponent
];

const declaredComponents21 = [
  AppComponent21,
  // CesiumDirective,
  DrawingEditorToolsComponent21,
  EventItemsComponent,
  DrawingHintComponent,
  ServerConnectionStatusComponent21,
  AfterSettingsComponent,
  ObjectOptionsComponent21,
  RotationOptionComponent21,
  BottomHintDirective,
  TooltipDirective,
  // WhiteTooltipDirective,
  ItemSettingsComponent21,
  BeforeItemComponent,
  MapViewsComponent21,
  ConcreteLayersComponent,
  CameraRotateThreeDComponent21,
  // BabyNumberComponent,
  BabyNumberComponent21,
  InfoWindowAfsComponent,
  ImageInputComponent,
  FileInputComponent,
  StorySlidesComponent,
  FixedSizeComponent21,
  OverlaysComponent,
  MultidropComponent,
  UndoComponent,
  SelectedItemsGroupComponent,
  SearchLocationComponent21,
  BwTogglerComponent21,
  OverlayComponent,
  ItemElementComponent,
  CanvasStoreComponent,
  GlobalObjectsLockComponent,
  LastHeaderBtnsComponent,
  MobileLastHeaderBtnsComponent,
  SocketConnectionModalComponent,
  RealtimeUsersComponent21,
  PlacedItems21Component,
  PlacedItemComponent,
  ItemDetailsSidebarComponent,
  ItemParticipantComponent21,
  ZoomControlsComponent21,
  InternalFloorsComponentComponent,
  VideoModalComponent,
  ItemLocationComponent,
  HomeLinkComponent,
  SearchResultContainerComponent,
  EsBootstrapAlertsComponent,
  ShareIconComponent,
  ArrowInSquareIconComponent,
  DownloadIconComponent,
  MonitorIconComponent,
  ModalComponent,
  LinkShareModalComponent,
  LinkShareAccessNudgeModalComponent,
];

const declaredComponents = (window['isNewDesign21']) ? [].concat(declaredComponents21, []) : [].concat(declaredComponents2, []);
let entryComponents = (window['isNewDesign21'])
  ? [].concat([
    InfoWindowAfsComponent,
    BabyNumberComponent21,
    EditEventModalComponent,
    CustomerStoriesModalComponent,
    LinkShareModalComponent,
    LinkShareAccessNudgeModalComponent,
  ], [])
  : [].concat([
    InfoWindowAfsComponent,
    BabyNumberComponent,
    EditEventModalComponent,
    CustomerStoriesModalComponent,
  ], []);
plugins.forEach(plugin => {
  const c = plugin.getComponentForLocation(null);
  if (c) {
    entryComponents = entryComponents.concat(c);
  }
});
const mainComponent = (window['isNewDesign21']) ? AppComponent21 : AppComponent;
const adapterService = CesiumAdapterService;

const importsArr:any[] = [
  BrowserModule,
  CommonModule,
  HttpClientModule,
  FontAwesomeModule,
  FormsModule,
  ReactiveFormsModule,
  NgxSliderModule,
  BrowserAnimationsModule,
  ModalModule.forRoot(),
  TabsModule.forRoot(),
  TypeaheadModule.forRoot(),
  NgDragDropModule.forRoot(),
  AutocompleteLibModule,
  ToastModule,
  ColorPickerModule,
  DemoMaterialModule,
  CoreModule,
  UserGuideModule,
  SharedModule,
  PaywallModule.forRoot(),
  WhiteTooltipModule,
  CarouselModule.forRoot()
];

if (window['isIOS']()){
  importsArr.push(AutosizeModule)
}

@NgModule({
  declarations: [
    declaredComponents,
    FilterPipe,
    SortByPipe,
    GroupByPipe,
    GroupByTimeline,
    GroupByOverlayGroupPipe,
    filterByFieldLength,
    PerspectivesComponent,
    SidebarParticipantComponent,
    EventsListSelectComponent,
    Draggable,
    LayoutsTabComponent,
    OverlayTabItemComponent,
    OverlayType2TabItemComponent,
    GlobalMeasurementComponent,
    LockModalComponent,
    RotateHandlerComponent,
    NextSiblingComponentComponent,
    TimelineComponent,
    TimelineSliderComponent,
    ImageModalComponent,
    GlobalScreenshotComponent,
    ConfirmModalComponent,
    EmailSendingConfirmModalComponent,
    DownloadModalComponent,
    LeftSidebarSubitemComponent,
    ObjectArrayComponent,
    GpxImportComponent,
    GpxModalComponent,
    ImportsContainerComponent,
    CadAutoImportComponent,
    CadAutoImportModalComponent,
    CadAutoConfirmComponent,
    AutoCadSaveComponent,
    MyPositionComponent,
    HomeLinkComponent,
    TutorialListComponent,
    VersionsComponent,
    ImagePanolensComponent,
    PagePreloadComponent,
    GeneratePresentationModalComponent,
    PptxStoryModalComponent,
    EditStoryComponent,
    SlideNameComponent,
    EditEventModalComponent,
    CustomerStoriesModalComponent,
    CustomerStoryPreviewComponent,
    CmsNotificationComponent,
    PlacedItemConcreteComponent,
    PlacedItemItemComponent,
    ItemFolder,
    ItemAdditionalBlockComponent,
    ItemAdditionalActionsComponent,
    ItemAdditionalBlockListComponent,
    GroupAdditionalBlockComponent,
    GroupAdditionalBlockListComponent,
    GroupSidebarComponent,
    GroupRemoveConfirmationModalComponent,
    MapMoveComponent,
    OpacitySliderComponent,
    CloseAlertsDirective,
    SceneRotationComponent,
    BetaBadgeComponent,
    ExportProgressIndicatorComponent,
    EditStoryHiddenContainerComponent,
    PresetComponent,
    MultiSelectSquareToolComponent,
    ExchangeItemsComponent,
    MultiselectTopGroupComponent,
    MultiSelectFloorplanModal,
    NearmapLimitComponent,
    VertexModalComponent,
    VertexOptionButtonComponent,
    ObjectArrayConfirmModalComponent
  ],
  imports: importsArr,
  providers: [
    adapterService,
    UiAdapterService,
    DecimalPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (heartbeatService: HeartbeatService) => {
        return () => heartbeatService.init();
      },
      deps: [HeartbeatService],
      multi: true
    },
  ],
  bootstrap: [mainComponent],
  entryComponents: entryComponents
})


//@ts-ignore
export class AppModule {
  constructor(customInjector: AppInjector, library: FaIconLibrary) {
    library.addIcons(
      faSquare, faCheckSquare, faChevronDown, faChevronUp, faChevronLeft, faChevronRight,
      faEllipsisV, faLock, faLockOpen, faMapPin, faEye,
      faEyeSlash, faFilter, faPlane, faEuroSign, faCalendar, faTrash,
      faPalette, faCopy, faPlusCircle, faStar, faUndo, faAdjust,
      faBuilding, faMapMarker, faSearch, faPlusSquare, faMinusSquare, faSync, faLink, faUnlock, faMap, faGlobeAmericas, faRedo, faExchangeAlt,
      faClock, faTag, faArrowCircleRight, faFilePdf, faFileImage, faFileUpload, faDesktop, faPlus, faAngleDoubleRight, faTimesCircle,
      faCheck, faArrowAltCircleUp, faObjectUngroup, faObjectGroup, faExclamationCircle, faPencilAlt, faMapMarkerAlt
    );
  }
}
